{
  "schema_version": "1.0",
  "run_id": "run_20260712_130000_ist",
  "edition_key": "2026-07-12-1300-Asia-Kolkata",
  "created_at": "2026-07-12T07:35:00Z",
  "title": "दोपहर की स्रोत-जाँची खबरें",
  "caption": "2 मिनट · 3 खबरें · 3/3 दावा स्रोत-जाँचा",
  "episode_slug": "2026-07-12-1300",
  "audio_path": "runs/run_20260712_130000_ist/episode.mp3",
  "audio_sha256": "a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2",
  "transcript_path": "runs/run_20260712_130000_ist/script.final.json",
  "source_count": 3,
  "claim_counts": {"pass": 3, "rewrite": 0, "block": 0},
  "destinations": [
    {
      "destination": "telegram",
      "state": "SUCCEEDED",
      "idempotency_key": "2026-07-12-1300-Asia-Kolkata:telegram",
      "external_id": "msg_789",
      "external_url": "https://t.me/c/1234567890/789",
      "error": null
    },
    {
      "destination": "r2",
      "state": "SUCCEEDED",
      "idempotency_key": "2026-07-12-1300-Asia-Kolkata:r2",
      "external_id": "episodes/2026-07-12-1300.mp3",
      "external_url": "https://audio.overnightnewsroom.in/episodes/2026-07-12-1300.mp3",
      "error": null
    }
  ],
  "telegram_target": "telegram:-1001234567890"
}
